import React from 'react';
import { Check, Square } from 'lucide-react';

/**
 * Mostra in modo leggibile un testo con una formattazione minima in stile Markdown
 * (usata dalle sezioni cliente compilate dall'onboarding):
 *   ## / ### titoli · "- " elenchi · "- [x]" / "- [ ]" spunte · **grassetto**
 * Costruisce elementi React (nessun HTML grezzo): il testo resta sempre sicuro.
 * Un testo senza questi simboli viene mostrato esattamente com'è.
 */
function inline(testo, key) {
  const parti = testo.split(/(\*\*[^*]+\*\*)/g);
  return parti.map((p, i) => (p.startsWith('**') && p.endsWith('**') && p.length > 4
    ? <strong key={`${key}-${i}`} style={{ color: 'var(--text)', fontWeight: 650 }}>{p.slice(2, -2)}</strong>
    : <React.Fragment key={`${key}-${i}`}>{p}</React.Fragment>));
}

export default function TestoFormattato({ testo, style }) {
  const righe = String(testo || '').split('\n');
  const blocchi = [];
  let lista = null;
  const chiudiLista = () => { if (lista) { blocchi.push(lista); lista = null; } };

  righe.forEach((r, i) => {
    const t = r.trimEnd();
    const h = t.match(/^(#{2,3})\s+(.*)$/);
    const spunta = t.match(/^\s*[-*]\s+\[([ xX])\]\s+(.*)$/);
    const voce = !spunta && t.match(/^\s*[-*]\s+(.*)$/);
    if (h) {
      chiudiLista();
      const grande = h[1].length === 2;
      blocchi.push(
        <div key={i} style={{ fontSize: grande ? 15 : 13.5, fontWeight: 650, color: 'var(--text)', margin: blocchi.length ? (grande ? '18px 0 6px' : '14px 0 6px') : '0 0 6px' }}>
          {inline(h[2], i)}
        </div>,
      );
    } else if (spunta || voce) {
      if (!lista) lista = <ul key={`l${i}`} style={{ listStyle: 'none', padding: 0, margin: '2px 0', display: 'flex', flexDirection: 'column', gap: 4 }}>{[]}</ul>;
      const item = spunta ? (
        <li key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
          {/[xX]/.test(spunta[1]) ? <Check size={15} color="var(--green)" style={{ flexShrink: 0, marginTop: 2 }} /> : <Square size={14} color="var(--text-dim)" style={{ flexShrink: 0, marginTop: 3 }} />}
          <span style={{ color: /[xX]/.test(spunta[1]) ? 'var(--text-muted)' : 'var(--text)' }}>{inline(spunta[2], i)}</span>
        </li>
      ) : (
        <li key={i} style={{ display: 'flex', gap: 8 }}>
          <span style={{ color: 'var(--text-dim)' }}>•</span><span>{inline(voce[1], i)}</span>
        </li>
      );
      lista = React.cloneElement(lista, {}, [...React.Children.toArray(lista.props.children), item]);
    } else if (!t.trim()) {
      chiudiLista();
      blocchi.push(<div key={i} style={{ height: 6 }} />);
    } else {
      chiudiLista();
      blocchi.push(<div key={i}>{inline(t, i)}</div>);
    }
  });
  chiudiLista();
  return <div style={{ fontSize: 13.5, lineHeight: 1.6, color: 'var(--text)', wordBreak: 'break-word', ...style }}>{blocchi}</div>;
}
